export enum FieldType {
    autoComplete = 'autoComplete',
    dateTime = 'dateTime',
    deprecatedRichEditor = 'deprecatedRichEditor',
    file = 'file',
    hidden = 'hidden',
    label = 'label',
    number = 'number',
    paragraph = 'paragraph',
    richEditor = 'richEditor',
    select = 'select',
    switch = 'switch',
    text = 'text',
    textarea = 'textarea',
    url = 'url',
    radioButtons = 'radioButtons',
    component = 'component',
}
